import api from '@/api'

const SET_DELIVERIES = 'SET_DELIVERIES'
const SET_FILTERS = 'SET_FILTERS'
const RESET_FILTERS = 'RESET_FILTERS'

const SET_COMPANIES = 'SET_COMPANIES'
const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'
const UNSET_CURRENT_COMPANY = 'UNSET_CURRENT_COMPANY'

export default {
  namespaced: true,

  state () {
    return {
      filters: {},
      hasFilters: false,
      deliveries: [],
      companies: [],
      currentCompany: null
    }
  },

  getters: {
    deliveries: (state) => state.deliveries,
    totalCount: (state) => state.deliveries.count || 0,
    filters: (state) => state.filters,
    hasFilters: (state) => state.hasFilters,
    deliveryCompanies: (state) => state.companies,
    currentCompany: (state) => state.currentCompany
  },

  mutations: {
    [SET_DELIVERIES] (state, data) {
      state.deliveries = data
    },

    [SET_FILTERS] (state, data) {
      state.filters = data
      if (Object.keys(state.filters).length) {
        state.hasFilters = true
      } else {
        state.hasFilters = false
      }
    },

    [RESET_FILTERS] (state) {
      state.filters = {
        farm: state.filters.farm
      }
      state.hasFilters = false
    },

    [SET_COMPANIES] (state, data) {
      state.companies = data
    },

    [SET_CURRENT_COMPANY] (state, data) {
      state.currentCompany = data
    },

    [UNSET_CURRENT_COMPANY] (state) {
      state.currentCompany = null
    }
  },

  actions: {
    async loadDeliveries ({ commit, state }, params = {}) {
      for (const key in params) {
        state.filters[key] = params[key]
      }
      const filters = {}
      for (const key in state.filters) {
        filters[key] = state.filters[key]
      }
      const { data } = await api.deliveries.list(filters)
      commit(SET_DELIVERIES, data || [])
    },

    setFilters ({ commit }, params = {}) {
      commit(SET_FILTERS, params)
    },

    resetFilters ({ commit }) {
      commit(RESET_FILTERS)
    },

    async createDelivery ({ dispatch }, payload) {
      const res = await api.deliveries.create(payload)
      if (!res.errors) {
        dispatch('loadDeliveries', { farm: payload.farm })
      }
      return res
    },

    async loadCompanies ({ commit }, params) {
      const filters = { farm: params.farm }
      const { data } = await api.deliveries.companies.list(filters)
      commit(SET_COMPANIES, data || [])
    },

    async createCompany ({ dispatch }, payload) {
      // await api.deliveries.companies.create(payload)
      await dispatch('loadCompanies', { farm: payload.farm })
    },

    async openCompanyDetail ({ commit }, id) {
      const { data } = await api.deliveries.companies.getById(id)
      commit(SET_CURRENT_COMPANY, data)
    },

    async saveCompanyDetail ({ commit, dispatch, getters }) {
      const item = getters.currentCompany
      // await api.deliveries.companies.updateById(item.id, item)
      const params = { farm: item.farm }
      dispatch('loadCompanies', params)
      commit(UNSET_CURRENT_COMPANY)
    },

    async deleteCompany ({ commit, dispatch, getters }) {
      const item = getters.currentCompany
      await api.deliveries.companies.deleteById(item.id)
      const params = { farm: item.farm }
      dispatch('loadCompanies', params)
      commit(UNSET_CURRENT_COMPANY)
    },

    closeCompanyDetail ({ commit }) {
      commit(UNSET_CURRENT_COMPANY)
    }
  }
}
